import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook_icon",
  "use": "icon-facebook_icon-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook_icon\"><path d=\"M24 0C10.746 0 0 10.746 0 24C0 37.254 10.746 48 24 48C37.254 48 48 37.254 48 24C48 10.746 37.254 0 24 0ZM30 16H27.3C26.224 16 26 16.442 26 17.556V20H30L29.582 24H26V38H20V24H16V20H20V15.384C20 11.846 21.862 10 26.058 10H30V16Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol